import _ from 'underscore';
import BaseView from './baseView.js';
import * as uuid from 'uuid';

const ESC = 27;

const defaults = {
  wait: false,
  closeable: true,
};

export default class Modal extends BaseView {
  className() {
    return 'modal ' + this.id;
  }

  initialize(options) {
    this.uuid = uuid.v4();
    this.extendableInitialize(options);
  }

  get bgTemplate() {
    return `<div class="modal-background loading ${this.uuid}"></div>`;
  }

  extendableInitialize(options) {
    this.opts = _.extend({}, defaults, options);
    this.$body = $('body');
    this.$background = this.$body.find(`.modal-background.${this.uuid}`);

    this._attachEvents();
  }

  /**
   * It closes the modal box
   *
   * return the modal object
   */
  close() {
    this.$el.removeClass('modal-fade-in');
    this.$background.removeClass('modal-fade-in');

    this.trigger('modalClosed');

    return this;
  }

  /**
   * It removes the modal from the DOM
   *
   * return the modal object
   */
  destroy() {
    var $document = $(document);

    this.close();
    this.remove();
    $document.off('click.modal' + this.cid);
    $document.off('keyup.modal' + this.cid);

    if (!$('.modal').length) {
      this.$background.remove();
    }

    return this;
  }

  /**
   * It sets the modal's content to be displayen
   *
   * return the modal object
   */
  setContent(content) {
    this.$el.html(content);
    this.trigger('modalContentSet', this.$el);

    return this;
  }

  /**
   * It displays the modal on screen
   *
   * return the modal object
   */
  show(position, size) {
    var self = this;

    this._showBackground();
    this._setPosition(position || this.opts.position);
    this._setSize(size || this.opts.size);
    this.waiting(false);

    self.$el.css({ display: 'block' });

    setTimeout(function () {
      self.$el.addClass('modal-fade-in');
    }, 100);

    return this;
  }

  /**
   * It sets the modal to be in waiting mode.
   *
   * return the current state of to be or not waiting (having or not the 'loading' class or not)
   */
  waiting(bool) {
    if (arguments.length === 1) {
      this.$el.toggleClass('loading', bool);
      this.$body.css('cursor', bool ? 'wait' : 'default');
    }

    return this.$el.hasClass('loading');
  }

  /**
   * Private helper functions below
   */
  _attachEvents() {
    var $document = $(document),
      escape = $.proxy(this._escape, this);

    $document.on(
      'click.modal' + this.cid,
      `.modal-background.${this.uuid}`,
      escape,
    );
    $document.on('keyup.modal' + this.cid, escape);
    this.$el.on('click', '.close-modal', escape);
    this.$el.on('click', '.cancel-modal', escape);
    this.$el.on('click', '.cancel-clone', escape);
  }

  _escape(e) {
    e.preventDefault();
    if (!this.opts.closeable) {
      return;
    }

    if (e.keyCode === ESC || e.type === 'click') {
      this.close();
      this.trigger('modalEscaped');
    }
  }

  render() {
    if (!this.$el.parentNode) {
      this.$body.append(this.$el);
    }

    this.$el.css({
      zIndex: this._getZIndex(false),
    });

    this.waiting(!this.opts.wait);

    if (!this.opts.wait) {
      this._showBackground();
    }
  }

  _getZIndex(background = true) {
    const order = background ? 1 : 2;

    return 301 + 2 * $('.modal-background').length + order;
  }

  _renderBackground() {
    this.$background = $(this.bgTemplate);
    this.$background.css({
      zIndex: this._getZIndex(),
    });
    this.$body.append(this.$background);
  }

  _setPosition(position) {
    if (!position) {
      return;
    }
    this.$el.css('top', position.top + 'px');
    this.$el.css('left', position.left + 'px');
  }

  _setSize(size) {
    if (!size) {
      return;
    }
    if (size.width) {
      this.$el.css('width', size.width);
    }
    if (size.width) {
      this.$el.css('width', size.height);
    }
  }

  _showBackground() {
    if (!this.$background.length) {
      this._renderBackground();
    }
    this.$background.css({ display: 'block' }).addClass('modal-fade-in');
  }
}
